import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_BEGIN,
  COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_SUCCESS,
  COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_FAILURE,
  COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteCollectionConstraint(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_BEGIN,
    });
    const { projectId, collectionUuid, constraintId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/constraints/${collectionUuid}/collection/${constraintId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_SUCCESS,
              data: res.data,
              collectionUuid: args.collectionUuid,
            });
            Mixpanel.track('Deleted collection constraint');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection constraint');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection constraint');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCollectionConstraintError() {
  return {
    type: COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_BEGIN:
      return {
        ...state,
        deleteCollectionConstraintPending: true,
        deleteCollectionConstraintError: null,
      };

    case COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index].constraints = action.data;
      return {
        ...state,
        deleteCollectionConstraintPending: false,
        deleteCollectionConstraintError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          constraints: action.data,
        },
      };

    case COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_FAILURE:
      return {
        ...state,
        deleteCollectionConstraintPending: false,
        deleteCollectionConstraintError: action.data.error,
      };

    case COLLECTIONS_DELETE_COLLECTION_CONSTRAINT_DISMISS_ERROR:
      return {
        ...state,
        deleteCollectionConstraintError: null,
      };

    default:
      return state;
  }
}
